import { useEffect } from 'react';
import { useIsMobile } from './use-mobile';

/**
 * Hook unifié consolidant toutes les optimisations de performance
 * Élimine la redondance et les conflits entre hooks multiples
 */
export const useUnifiedPerformance = (pathname?: string) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    // Utiliser requestIdleCallback pour les opérations non critiques
    const scheduleWork = (callback: () => void) => {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(callback, { timeout: 2000 });
      } else {
        setTimeout(callback, 1);
      }
    };

    // Images critiques - préchargées via HTML pour un FCP optimal
    // (Les preloads sont maintenant gérés dans index.html pour éviter les reflows)

    // DNS prefetch et preconnect - déjà gérés dans index.html pour un meilleur FCP

    // Optimisations spécifiques mobile - reporter après FCP
    if (isMobile) {
      scheduleWork(() => {
        // Optimisation du viewport
        const setVH = () => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setVH();
        const resizeHandler = () => setVH();
        window.addEventListener('resize', resizeHandler, { passive: true });

        // Styles CSS pour performances mobiles - injectés après le FCP
        if (!document.head.querySelector('#mobile-performance-styles')) {
          const mobileStyle = document.createElement('style');
          mobileStyle.id = 'mobile-performance-styles';
          mobileStyle.textContent = `
            @media (max-width: 768px) {
              * {
                animation-duration: 0.15s !important;
                transition-duration: 0.15s !important;
              }
              img, .hero, .navbar {
                transform: translateZ(0);
                will-change: transform;
              }
            }
          `;
          document.head.appendChild(mobileStyle);
        }
      });
    }
  }, [isMobile, pathname]);

  return { isMobile };
};
